import { type TPublicOfferBusinessEntityAcceptRequest } from 'shared/repositories/dailyrent/v1/public-offer/business-entity/accept';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/redux';
import { acceptBusinessEntityPublicOffer as acceptBusinessEntityPublicOfferService } from '../../../services/businessEntityFlow/acceptBusinessEntityPublicOffer';

export const acceptBusinessEntityPublicOffer = createAsyncThunk<
  void,
  TPublicOfferBusinessEntityAcceptRequest,
  IThunkApi & { rejectValue: { error: true } }
>('businessEntityFlow/acceptBusinessEntityPublicOffer', async (params, thunkApi) => {
  const { extra: context } = thunkApi;

  try {
    await acceptBusinessEntityPublicOfferService(context, params);

    return;
  } catch (error) {
    return thunkApi.rejectWithValue({ error });
  }
});
